/* eslint-disable max-len */
import {
  getPeriod, serverDate, uuid,
} from '../../utils/common';
import { errorMessage } from '../../utils/message';

// 참가 신청 버튼 이벤트
function applicationParticle() {
  const half = getPeriod('half', 'normal');
  const ten = getPeriod('ten', 'normal');
  if ((serverDate() >= half.open && serverDate() <= half.close) && (serverDate() >= ten.open && serverDate() <= ten.close)) {
    // eslint-disable-next-line no-alert
    alert(errorMessage.apply.finish.apply);
    return;
  }

  // eslint-disable-next-line no-restricted-globals
  location.href = uuid
    ? `../apply/part-agree.html?uuid=${uuid}`
    : '../apply/part-agree.html';
}

window.applicationParticle = applicationParticle;
